
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Onedaytournearbuldhana() {



  const cardData =
  {
    keyword: ' One Day Tour Near Buldhana',
    heading:  'Woodland Escape: One Day Tour Near Buldhana ',
    headingDescription: 'Woodland Escape Resort is the ideal choice for a one day tour near Buldhana, offering a refreshing escape into nature with lush greenery, open lawns, and peaceful surroundings just a short drive from the city. Perfect for families, friends, and groups, the resort provides a complete day of relaxation and recreation with outdoor games, nature walks, and cozy picnic spots. Guests can enjoy delicious homely meals, unwind in comfortable cottages, or simply bask in the calm beauty of the forest landscape. With warm hospitality, clean facilities, and scenic views all around, Woodland Escape Resort near Buldhana ensures every one-day trip becomes a memorable blend of fun, peace, and natural charm.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "One Day Tour Near Buldhana",
      "description": "Discover the best one-day tours near Buldhana offering scenic routes, cultural attractions, and peaceful picnic spots perfect for families, couples, and solo travelers. Enjoy a blend of natural beauty, historical sites, and local culture while exploring nearby destinations that promise relaxation and memorable experiences. Ideal for quick getaways and those seeking a refreshing break from routine."
    },
    {
      "name": "Buldhana Day Trip",
      "description": "Plan a refreshing day trip in Buldhana with exciting sightseeing options, delicious local cuisine, and beautiful surroundings perfect for a short yet fulfilling escape. Explore temples, gardens, lakes, and local markets while enjoying the serene ambiance of rural Maharashtra. A perfect option for travelers who wish to explore more in less time without compromising on comfort and experience."
    },
    {
      "name": "Buldhana Sightseeing Tour",
      "description": "Explore Buldhana’s top sightseeing destinations including historical landmarks, ancient temples, serene lakes, and lush greenery. This tour lets you witness the cultural essence and natural charm of the region through well-planned routes and local guides. Ideal for photography lovers, history enthusiasts, and nature admirers looking to capture the true spirit of Buldhana in a single day."
    },
    {
      "name": "Buldhana Short Trip",
      "description": "Enjoy a short and fulfilling trip around Buldhana with easy travel routes, popular attractions, and cozy resting spots to unwind. Whether it’s a spiritual visit, a family picnic, or a solo nature retreat, this short trip ensures you experience the highlights of Buldhana without an overnight stay. Perfect for spontaneous travelers or weekend explorers seeking quick adventures."
    },
    {
      "name": "Affordable One Day Tour Buldhana",
      "description": "Experience budget-friendly one-day tours in Buldhana that combine adventure, comfort, and sightseeing. Visit must-see attractions, scenic viewpoints, and local eateries without stretching your wallet. With affordable packages, transport options, and flexible itineraries, these tours cater to families, students, and groups looking for value-packed travel experiences around Buldhana."
    },
    {
      "name": "Buldhana Nearby Attractions Tour",
      "description": "Visit Buldhana’s nearby attractions such as Lonar Crater Lake, Sindkhed Raja Fort, and Dnyanganga Wildlife Sanctuary. Perfect for those wanting to explore the region’s hidden gems, this tour combines cultural heritage with natural beauty. Spend your day capturing scenic landscapes, visiting temples, and indulging in local flavors for an unforgettable experience near Buldhana."
    },
    {
      "name": "Buldhana Weekend Day Trip",
      "description": "Make your weekends memorable with a one-day getaway around Buldhana. Explore hilltops, lakesides, and temples while enjoying peaceful surroundings and fresh air. Perfect for families, friends, and couples who want to unwind after a busy week. With convenient travel options and fun-filled itineraries, this weekend trip offers the perfect blend of relaxation and exploration."
    },
    {
      "name": "Buldhana Family Day Trip",
      "description": "Plan a family-friendly day trip in Buldhana featuring activities for all ages, from scenic picnics to light trekking and cultural sightseeing. Enjoy well-maintained picnic areas, delicious local snacks, and beautiful viewpoints that ensure fun and comfort. Ideal for creating lasting memories with your loved ones while exploring the best of Buldhana’s nature and heritage."
    },
    {
      "name": "Buldhana Nature Day Tour",
      "description": "Reconnect with nature on a one-day tour around Buldhana surrounded by hills, rivers, and forest trails. Experience the tranquility of rural Maharashtra while exploring eco-friendly spots and untouched landscapes. Ideal for nature lovers, bird watchers, and peace seekers, this tour offers a rejuvenating experience away from city noise and stress."
    },
    {
      "name": "Buldhana City Day Tour",
      "description": "Discover the culture, lifestyle, and history of Buldhana city with a comprehensive one-day tour. Visit local landmarks, temples, parks, and marketplaces to experience the authentic charm of this vibrant district. Learn about local traditions, enjoy regional delicacies, and interact with friendly locals as you explore the heart of Buldhana in a day."
    },
    {
      "name": "Buldhana Riverside Day Tour",
      "description": "Enjoy a peaceful riverside day tour in Buldhana featuring scenic water views, picnic spots, and boating opportunities. Spend your day relaxing under the shade of trees, enjoying local snacks, or taking photographs of the calm and refreshing surroundings. A perfect outing for couples, families, or anyone looking to enjoy a tranquil experience near the water."
    },
    {
      "name": "Buldhana Hill Day Trip",
      "description": "Take a refreshing hill day trip near Buldhana and enjoy breathtaking panoramic views, cool breezes, and scenic trekking trails. Ideal for adventure enthusiasts and photographers, this trip offers a chance to experience nature’s beauty from elevated viewpoints. Visit popular hill areas or explore lesser-known spots for an unforgettable highland adventure."
    },
    {
      "name": "Buldhana Day Excursion Packages",
      "description": "Choose from curated day excursion packages in Buldhana that include comfortable transport, meals, sightseeing, and local guides. These packages are designed to provide convenience and value for travelers who want a complete experience without planning hassles. Whether you’re exploring with family, friends, or a tour group, enjoy a seamless and memorable journey through Buldhana."
    },
    {
      "name": "Buldhana Tour Booking",
      "description": "Easily book your Buldhana one-day tour online with flexible itineraries, affordable rates, and customizable options. Select from various themes like adventure, nature, or cultural exploration, and secure your booking with ease. Get instant confirmations, professional support, and exclusive deals for a stress-free travel experience in and around Buldhana."
    },
    {
      "name": "Buldhana One Day Outing",
      "description": "Plan a fun-filled one-day outing in Buldhana with friends or family featuring outdoor games, sightseeing, and delicious local meals. Choose from beautiful gardens, riversides, or hillsides for a relaxing and entertaining day out. Ideal for small groups or families looking to spend quality time together in a natural and peaceful environment."
    }
  ],
  "tableData": [
    ["- One Day Tour Near Buldhana", "- Buldhana Day Trip"],
    ["- Buldhana Sightseeing Tour", "- Buldhana Short Trip"],
    ["- Affordable One Day Tour Buldhana", "- Buldhana Nearby Attractions Tour"],
    ["- Buldhana Weekend Day Trip", "- Buldhana Family Day Trip"],
    ["- Buldhana Nature Day Tour", "- Buldhana City Day Tour"],
    ["- Buldhana Riverside Day Tour", "- Buldhana Hill Day Trip"],
    ["- Buldhana Day Excursion Packages", "- Buldhana Tour Booking"],
    ["- Buldhana One Day Outing", ""]
  ],
  


whychoose: [
  {
    "WhyChooseheading": "Perfect One Day Tour Near Buldhana",
    "WhyChoosedescription": "Woodland Escape Resort is an excellent destination for a one-day tour near Buldhana. Surrounded by natural beauty and peaceful greenery, it offers a rejuvenating escape from the daily routine without needing an overnight stay."
  },
  {
    "WhyChooseheading": "Serene Natural Environment",
    "WhyChoosedescription": "Experience tranquility amidst lush forests, open lawns, and fresh air. The resort’s natural setting makes it ideal for relaxation, photography, and spending peaceful moments with family or friends."
  },
  {
    "WhyChooseheading": "Fun-Filled Day Activities",
    "WhyChoosedescription": "From nature walks and cycling to outdoor games and pond-side relaxation, Woodland Escape Resort provides a range of enjoyable activities perfect for a short, refreshing break."
  },
  {
    "WhyChooseheading": "Comfortable Amenities for Day Visitors",
    "WhyChoosedescription": "Designed for convenience, the resort features shaded sit-outs, picnic spots, rest zones, and clean facilities — ensuring a comfortable and memorable one-day experience."
  },
  {
    "WhyChooseheading": "Delicious Local Cuisine",
    "WhyChoosedescription": "Savor freshly prepared local dishes, snacks, and beverages at the resort. The tasty food options enhance your day trip, making it not just relaxing but also deliciously satisfying."
  },
  {
    "WhyChooseheading": "Perfect for Families and Groups",
    "WhyChoosedescription": "Whether you’re planning a family day out, a friends’ reunion, or a small group getaway, the resort provides a safe and open environment for bonding, games, and shared fun."
  },
  {
    "WhyChooseheading": "Easy Accessibility from Buldhana",
    "WhyChoosedescription": "Located just a short drive from Buldhana, Woodland Escape Resort is ideal for a spontaneous day trip. Spend more time enjoying and less time on the road with this convenient location."
  }
]



















  
  



  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort for a one day tour near Buldhana?",
    answer: "Woodland Escape Resort is the perfect destination for a refreshing one day tour near Buldhana. Surrounded by lush greenery and peaceful nature, it offers relaxation, fun, and a complete escape from city life."
  },
  {
    question: "How far is Woodland Escape Resort from Buldhana city?",
    answer: "The resort is approximately 35–40 km from Buldhana, making it easily reachable within 1 to 1.5 hours by car — ideal for a quick one day getaway."
  },
  {
    question: "What can we do during a one day tour at Woodland Escape Resort?",
    answer: "Guests can enjoy open lawns, nature walks, cycling, outdoor games, and relaxing picnic spots. It’s a great place to unwind with family or friends and spend a fun-filled day."
  },
  {
    question: "Is the resort suitable for families and groups visiting for a one day tour?",
    answer: "Yes! Woodland Escape Resort is family-friendly and group-friendly. With safe surroundings, open spaces, and engaging activities, everyone can enjoy their time comfortably."
  },
  {
    question: "Are meals and refreshments available during the one day tour?",
    answer: "Absolutely. The resort offers freshly prepared meals, snacks, and beverages. You can also choose from special one day tour packages that include lunch and refreshments."
  },
  {
    question: "How can we book a one day tour at Woodland Escape Resort near Buldhana?",
    answer: "You can book your one day tour by calling or sending a WhatsApp message to our reservation team, or by visiting our official website. Advance booking is suggested for weekends and holidays."
  }
];

const testimonials = [
  {
    name: "Mr. Sandeep & Family, Buldhana",
    text: "We had an amazing one day tour at Woodland Escape Resort! The environment was peaceful, and the kids loved the open space. Perfect for a short and refreshing getaway near Buldhana."
  },
  {
    name: "Mrs. Komal & Friends, Buldhana",
    text: "Woodland Escape Resort was the best choice for our one day tour! Everything from the food to the natural surroundings was perfect. Highly recommended for anyone near Buldhana."
  }
];


















      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "One Day Tour Near Buldhana",
  "image": "https://woodlandescape.com/assets/images/one-day-tour-buldhana.jpg",
  "description": "Experience a memorable one day tour near Buldhana at Woodlandescape Resort. Enjoy scenic nature, riverside views, outdoor activities, and fun-filled family excursions for a perfect weekend getaway.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "187"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1299",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/one-day-tour-buldhana"
  }
};



  return (
    <div>
<Helmet>
  <title>One Day Tour Near Buldhana | Scenic & Fun Family Outing | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Plan a fun-filled one day tour near Buldhana at Woodlandescape Resort. Enjoy scenic nature, riverside views, outdoor activities, and memorable family excursions for a perfect weekend getaway." 
  />
  <meta 
    name="keywords" 
    content="One Day Tour Near Buldhana, Buldhana Day Trip, Buldhana Sightseeing Tour, Buldhana Short Trip, Affordable One Day Tour Buldhana, Buldhana Nearby Attractions Tour, Buldhana Weekend Day Trip, Buldhana Family Day Trip, Buldhana Nature Day Tour, Buldhana City Day Tour, Buldhana Riverside Day Tour, Buldhana Hill Day Trip, Buldhana Day Excursion Packages, Buldhana Tour Booking, Buldhana One Day Outing" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/21.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Onedaytournearbuldhana;